import React, {
  ReactNode,
  SyntheticEvent,
  useEffect,
  useState,
  useMemo,
  useRef,
} from "react";
import { Badge, Checkbox, Label, Tooltip, useThemeMode } from "flowbite-react";
import toast from "react-hot-toast";
import { useOrganizationService, useRoadmapService } from "../../services";
import { useJwt } from "../../helpers/common";
import { Drawer } from "../../components/Modals";
import { useDispatch, useSelector } from "react-redux";
import { formatDateBy } from "../../helpers/data-format";
// @ts-ignore
import DatePicker from "react-datepicker";
import CustomButton from "../../components/common/CustomButton";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Select, { components, MultiValue, SingleValue } from "react-select";
import RichTextEditor from "../../components/RichTextEditor";
import CustomDropdown from "../../components/common/CustomDropdown";
import { setSingleRoadmap } from "../../redux/slices/roadmap";
import { setSearchTerm } from "../../redux/slices/organization";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { HiLink, HiTrash } from "react-icons/hi";
import { useIntegrationStatus } from "../../hooks/useIntegrationStatus";
import moment from "moment";
import { getDefaultUserName } from "../../constants/defaultUsers";
import { useResourceInfo } from "../../hooks/useResourceInfo";
import { defaultWorkingDays, getOrgWorkingDays } from "../../utils/helperUtils";
import RoadmapDeleteModal from "../../components/Modals/RoadmapDeleteModal";
import UnsavedChangesIndicator from "../../components/common/UnsavedChangesIndicator";
import { Chip } from "@mui/material";
import { getEntityTypeDisplay } from "../../utils/entityDisplayUtils";
import HeadlessSelect from "../../shared/atoms/HeadlessSelect";
import EntityItem from "../SelectEntity/EntityItem";
import { FaCross, FaPlusCircle, FaSearch, FaTimes, FaXbox } from "react-icons/fa";
import SortByDropdown from "../../components/common/SortByDropdown";
import EntityItemSkeleton from "../SelectEntity/EntityItemSkeleton";
import CreateFeatureModal from "../CreateWorkUnit/components/CreateFeatureModal";

// Enhanced Project Skeleton Component that exactly matches the actual project items
const EnhancedProjectSkeleton = ({
  isReadOnly = false,
}: {
  isReadOnly?: boolean;
}) => {
  return (
    <div className="flex">
      {!isReadOnly && (
        <div className="w-4 h-4 mr-4 bg-light-surfaceSecondary dark:bg-hover-dark border border-light-border-default dark:border-hover-dark rounded animate-pulse"></div>
      )}
      <div className="grid grid-cols-12 gap-4 p-3 items-center relative group rounded-lg border border-light-border-emphasis dark:border-hover-dark bg-white dark:bg-secondary-dark w-full hover:bg-light-surfaceHover dark:hover:bg-hover-dark hover:border-light-border-interactive dark:hover:border-gray-500 transition-all duration-200 shadow-sm hover:shadow-md">
        <div className="flex col-span-6 min-w-0">
          <div className={`${!isReadOnly ? "ml-10" : ""} min-w-0`}>
            <div className="h-2 w-14 bg-light-surfaceSecondary dark:bg-hover-dark rounded mb-2 opacity-60 animate-pulse"></div>
            <div
              className={`h-4 ${!isReadOnly ? "w-36" : "w-3/4"} bg-light-surfaceSecondary dark:bg-hover-dark rounded animate-pulse`}
            ></div>
          </div>
        </div>
        <div className="col-span-3 min-w-0">
          <div className="h-2 w-16 bg-light-surfaceSecondary dark:bg-hover-dark rounded mb-2 opacity-60 animate-pulse"></div>
          <div className="h-4 w-24 bg-light-surfaceSecondary dark:bg-hover-dark rounded animate-pulse"></div>
        </div>
        <div className="col-span-3 min-w-0">
          <div className="h-2 w-24 bg-light-surfaceSecondary dark:bg-hover-dark rounded mb-2 opacity-60 animate-pulse"></div>
          <div className="h-4 w-28 bg-light-surfaceSecondary dark:bg-hover-dark rounded animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};

// Interface for TabPanel
interface TabPanelProps {
  children?: ReactNode;
  index: number;
  value: number;
}

interface CreateRoadMapsModalProps {
  setShowModal?: any;
  setSelectedRoadmap?: any;
  isVisible?: any;
  roadmap?: any;
  org_id?: any;
  shouldScrollToTabs?: boolean;
  type?: string;
  onCreate?: (data?: any) => void;
  preventRedirect?: boolean;
}

interface Milestone {
  _uid: string;
  name: string;
  color: string;
  start_date: Date;
  id: number;
}

interface Dependency {
  _uid: string;
  project_to: {
    value: string;
    label: string;
    start_date: any;
    project_end_date: any;
  };
  project_on: any[];
}

interface ProjectData {
  id?: string;
  name?: string;
  project_id?: string;
  project_name?: string;
  description?: string;
  start_date?: string;
  end_date?: string;
  project_end_date?: string;
  project_ids?: string[];
  stage?: string;
  [key: string]: any; // Allow for additional properties
}

const CustomTabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
};

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const CreateEpicAdvancedModalBody = ({
  setShowModal,
  setSelectedRoadmap,
  isVisible = false,
  roadmap = {},
  shouldScrollToTabs = false,
  type,
  onCreate,
  preventRedirect = false,
}: CreateRoadMapsModalProps) => {
  const { id: roadmap_id = "" } = roadmap;
  const { roadmap_id: roadmapIdArg } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const JWTdata: any = useJwt();
  const org_id = roadmap.org_id || JWTdata.org_id;
  const [refreshKey, setRefreshKey] = useState(0);
  const [milestones, setMilestones] = useState<Milestone[]>([]);
  const [dependencies, setDependencies] = useState<Dependency[]>([]);
  const [selectedProjects, setSelectedProjects] = useState<ProjectData[]>([]);
  const [pinnedProjects, setPinnedProjects] = useState<ProjectData[]>([]);
  const [payloadData, setPayloadData] = useState<ProjectData>({
    name: "",
    description: "",
    project_ids: [],
    priority: "",
  });
  const [drawerKey, setDrawerKey] = useState<number>(0);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const isDataSyncedRef = useRef<boolean>(false);
  const syncTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const tabsRef = useRef<HTMLDivElement>(null);
  const searchDebounceRef = useRef<NodeJS.Timeout | null>(null);

  const { dashboardDetails } = useSelector((state: any) => state.timeline);

  const [searchQuery, setSearchQuery] = useState("");
  const [activeTabs, setActiveTabs] = useState(0);
  const [mode] = useThemeMode();
  const dispatch = useDispatch();

  const [showCreateFeature, setShowCreateFeature] = useState(false);

  const handleFeatureCreated = (newFeature: any) => {
    if (newFeature) {
      setSelectedProjects((prev) => {

        const exists = prev.some(
          (p) =>
            p.project_id === newFeature.project_id ||
            p.id === newFeature.project_id
        );
        if (exists) return prev;
        // Ensure minimal ProjectData structure
        const featureData: ProjectData = {
          ...newFeature,
          id: newFeature.project_id,
          project_id: newFeature.project_id,
          project_name: newFeature.project_name,
        };
        return [...prev, featureData];
      });

      setRefreshKey(pv=>pv+1)
    }
    setShowCreateFeature(false);
  };

  const { saveRoadmap, updateRoadmap, fetchSingleRoadmap, deleteRoadmap } =
    useRoadmapService();
  const { fetchProjectsList } = useOrganizationService();
  const { shouldShowIntegration } = useIntegrationStatus();
  const { getResourceName } = useResourceInfo();

  const {
    saveRoadmapLoading,
    singleRoadmapLoading,
    singleRoadmapRes = {},
  } = useSelector((state: any) => state.roadmap);

  const {
    orgSchedule: organizationHolidays = [],
    orgDetails,
    data: projects,
    loading: orgLoading,
    loadingMore = false,
    hasMore = false,
    page = 1,
    searchTerm = "",
    totalItems = 0,
  } = useSelector((state: any) => state.organization);

  const organizationWorkingDays = getOrgWorkingDays(org_id || "");

  const holidayDateSet = React.useMemo(() => {
    const set = new Set<string>();
    try {
      organizationHolidays?.forEach((h: any) => {
        const raw = (h?.date ?? "").toString();
        if (!raw) return;
        const ymd = raw.includes("T") ? raw.split("T")[0] : raw;
        if (ymd) set.add(ymd);
      });
    } catch {}
    return set;
  }, [organizationHolidays]);

  const isDateSelectable = React.useCallback(
    (date: Date) => {
      if (!(date instanceof Date) || isNaN(date.getTime())) return false;
      const jsDay = date.getDay(); // 0..6
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, "0");
      const d = String(date.getDate()).padStart(2, "0");
      const ymd = `${y}-${m}-${d}`;
      const isHoliday = holidayDateSet.has(ymd);
      const hasConfiguredWorkingDays =
        Array.isArray(organizationWorkingDays) &&
        organizationWorkingDays.length > 0;
      const workingDays = hasConfiguredWorkingDays
        ? organizationWorkingDays
        : defaultWorkingDays;
      const isWorkingDay =
        Array.isArray(workingDays) && workingDays.includes(jsDay);
      return isWorkingDay && !isHoliday;
    },
    [holidayDateSet, organizationWorkingDays],
  );

  const internalPriorities = useMemo(
    () => orgDetails?.priorities ?? [],
    [orgDetails?.priorities]
  );

  const internalPriorityOptions = useMemo(() => {
    return internalPriorities.map((p: any, i: any) => ({
      value: p.id,
      label: `P${i + 1}`,
      color: p.color,
    }));
  }, [internalPriorities]);

  const transformProjectDependencyData = (
    data: any[],
    projectsData: ProjectData[],
  ) => {
    return data.map((project) => {
      const dependencies = project.dependency || [];
      const projectInfo =
        projectsData.find((p) => p.project_id === project.project_id) || {};

      // project_to is project and project_on is its dependency
      return {
        _uid: `${new Date().getTime().toString()}_${Math.floor(100000 + Math.random() * 900000)}`,
        project_to: {
          value: project.project_id,
          label: projectInfo?.project_name || "",
          start_date: projectInfo?.start_date,
          project_end_date: projectInfo?.end_date,
        },
        project_on: dependencies.map((dep: { project_id: any }) => {
          const depProjectInfo =
            projectsData.find((p) => p.project_id === dep.project_id) || {};
          return {
            value: dep.project_id,
            label: depProjectInfo.project_name || "",
            project_id: dep.project_id,
            project_end_date: depProjectInfo?.start_date,
            project_start_date: depProjectInfo?.end_date,
          };
        }),
      };
    });
  };

  useEffect(() => {
    return () => {
      if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
    };
  }, []);

  useEffect(() => {
    // Keep local search query and Redux searchTerm in sync only in editable mode
    const readOnly = Boolean(singleRoadmapRes?.integration_data);
    if (!readOnly) {
      setSearchQuery(searchTerm);
    }
  }, [searchTerm, singleRoadmapRes?.integration_data]);

  useEffect(() => {
    if (
      roadmap_id &&
      singleRoadmapRes &&
      Object.keys(singleRoadmapRes).length > 0 &&
      !singleRoadmapLoading
    ) {
      if (syncTimeoutRef.current) clearTimeout(syncTimeoutRef.current);
      isDataSyncedRef.current = false;
      setPayloadData({ ...singleRoadmapRes });
      if (singleRoadmapRes.project_ids) {
        setSelectedProjects(singleRoadmapRes.projects);
        setPinnedProjects(singleRoadmapRes.projects);
      }
      if (singleRoadmapRes?.milestones) {
        setMilestones(singleRoadmapRes.milestones);
      }
      if (singleRoadmapRes?.dependencies) {
        const d = transformProjectDependencyData(
          singleRoadmapRes?.dependencies,
          singleRoadmapRes?.projects || [],
        );
        setDependencies(d);
      }
      syncTimeoutRef.current = setTimeout(() => {
        isDataSyncedRef.current = true;
      }, 250);
    } else if (!roadmap_id) {
      isDataSyncedRef.current = false;
    }
    return () => {
      if (syncTimeoutRef.current) clearTimeout(syncTimeoutRef.current);
    };
  }, [singleRoadmapRes, orgLoading, roadmap_id, singleRoadmapLoading]);

  useEffect(() => {
    const readOnly = Boolean(singleRoadmapRes?.integration_data);
    if (!readOnly && org_id) {
      // Initial fetch only; subsequent searches are handled by handleSearchChange
      fetchProjectsList({
        org_id,
        reset: true,
        pageNumber: 1,
        searchTerm: "",
        include_data: ["roadmap_data"],
        item_type: "feature",
      });
    }
  }, [org_id, singleRoadmapRes?.integration_data, refreshKey]);

  useEffect(() => {
    if (roadmap_id && !roadmapIdArg) {
      fetchSingleRoadmap(roadmap_id, false);
    }
  }, [roadmap_id]);

  useEffect(() => {
    if (isVisible && shouldScrollToTabs && tabsRef.current) {
      setTimeout(() => {
        tabsRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 300); // Small delay to ensure modal is fully rendered
    }
  }, [isVisible, shouldScrollToTabs]);

  // When opening a new Strategy Map, reset local state and clear previous singleRoadmap
  useEffect(() => {
    if (isVisible && !roadmap_id) {
      setSelectedProjects([]);
      setPinnedProjects([]);
      setDependencies([]);
      setMilestones([]);
      setSearchQuery("");
      dispatch(setSearchTerm(""));
      setPayloadData({
        name: "",
        description: "",
        project_ids: [],
        priority: "",
      });
      dispatch(setSingleRoadmap({}));
      setDrawerKey(Date.now());
      setActiveTabs(0);
    }
  }, [isVisible, roadmap_id]);

  // Helper function to get the dynamic child entity type from dashboard state
  const getChildEntityType = () => {
    if (dashboardDetails?.childEntityType) {
      return dashboardDetails.childEntityType;
    }

    // Default fallback
    return "Work Units";
  };

  // Helper function to get the entity type (Roadmap, Project, etc.) from dashboard state
  const getEntityType = () => {
    if (dashboardDetails?.entityType) {
      return dashboardDetails.entityType;
    }

    // Default fallback to "Strategic Map" if not available
    return "Strategy Map";
  };

  // Helper function to get singular version of entity type
  const getSingularMainEntityType = (entityType: string) => {
    if (!entityType) return "Strategy Map";

    const lower = entityType.toLowerCase();

    // Special cases for common entity types
    if (lower === "strategy maps") {
      return "Strategy Map";
    }
    if (lower === "roadmaps") {
      return "Roadmap";
    }
    if (lower === "projects") {
      return "Work Unit";
    }
    if (lower === "jira projects") {
      return "Jira Project";
    }

    // Words ending in -ies (e.g., Stories -> Story, Companies -> Company)
    if (lower.endsWith("ies")) {
      return entityType.slice(0, -3) + "y";
    }

    // Words ending in -es after s, x, z, ch, sh (e.g., Boxes -> Box, Dishes -> Dish)
    if (
      lower.endsWith("es") &&
      (lower.endsWith("ses") ||
        lower.endsWith("xes") ||
        lower.endsWith("zes") ||
        lower.endsWith("ches") ||
        lower.endsWith("shes"))
    ) {
      return entityType.slice(0, -2);
    }

    // Words ending in -ves (e.g., Lives -> Life, Knives -> Knife)
    if (lower.endsWith("ves")) {
      return entityType.slice(0, -3) + "fe";
    }

    // Words ending in -s but not -ss (e.g., Strategy Maps -> Strategy Map)
    if (lower.endsWith("s") && !lower.endsWith("ss")) {
      return entityType.slice(0, -1);
    }

    // Return as-is if no plural pattern matches
    return entityType;
  };

  // Helper function to convert plural to singular like in DependencyForm
  const getSingularEntityType = (entityType: string) => {
    if (!entityType) return "Work Unit";

    const lower = entityType.toLowerCase();

    // Special case: Tasks should become User Story
    if (lower === "tasks") {
      return "User Story";
    }

    // Words ending in -ies (e.g., Stories -> Story, Companies -> Company)
    if (lower.endsWith("ies")) {
      return entityType.slice(0, -3) + "y";
    }

    // Words ending in -es after s, x, z, ch, sh (e.g., Boxes -> Box, Dishes -> Dish)
    if (
      lower.endsWith("es") &&
      (lower.endsWith("ses") ||
        lower.endsWith("xes") ||
        lower.endsWith("zes") ||
        lower.endsWith("ches") ||
        lower.endsWith("shes"))
    ) {
      return entityType.slice(0, -2);
    }

    // Words ending in -ves (e.g., Lives -> Life, Knives -> Knife)
    if (lower.endsWith("ves")) {
      return entityType.slice(0, -3) + "fe";
    }

    // Words ending in -s but not -ss (e.g., Projects -> Project, but not Glass -> Glas)
    if (lower.endsWith("s") && !lower.endsWith("ss")) {
      return entityType.slice(0, -1);
    }

    // Return as-is if no plural pattern matches
    return entityType;
  };

  const childEntityType = getChildEntityType();
  const singularEntityType = getSingularEntityType(childEntityType);
  const entityType = getEntityType();
  const singularEntityType_Main = getSingularMainEntityType(entityType);
  // Read-only when integration data exists
  const isIntegrationReadOnly = Boolean(singleRoadmapRes?.integration_data);

  // Always reset search when the modal opens
  useEffect(() => {
    if (isVisible) {
      setSearchQuery("");
      if (!isIntegrationReadOnly) {
        dispatch(setSearchTerm(""));
      }
    }
  }, [isVisible, isIntegrationReadOnly]);

  useEffect(() => {
    if (selectedProjects.length === 0) {
      if (activeTabs === 2) {
        setActiveTabs(1);
      }
    } else {
      if (activeTabs > 2) {
        setActiveTabs(0);
      }
    }
  }, [selectedProjects.length]);

  const hasUnsavedChanges = useMemo(() => {
    if (
      singleRoadmapLoading ||
      !roadmap_id ||
      !singleRoadmapRes ||
      Object.keys(singleRoadmapRes).length === 0     ) {
      return false;
    }

    const normalizeDescription = (desc: string) => {
      if (!desc) return "";
      try {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = desc;
        const textContent = tempDiv.textContent || tempDiv.innerText || "";
        let normalized = textContent.replace(/\s+/g, " ");
        normalized = normalized.replace(/\s+([,.!?;:])/g, "$1");
        return normalized.trim();
      } catch (error) {
        console.warn(
          "DOM-based HTML parsing failed, using regex fallback:",
          error,
        );
        let normalized = desc.replace(/<[^>]*>/g, "");
        normalized = normalized.replace(/\s+/g, " ");
        normalized = normalized.replace(/\s+([,.!?;:])/g, "$1");
        return normalized.trim();
      }
    };

    const normalizePriority = (val: any) => {
      if (val === null || val === undefined || val === "") return "";
      return String(val).trim();
    };

    const nameChanged = payloadData.name !== singleRoadmapRes.name;

    const currentDescRaw = payloadData.description || "";
    const initialDescRaw = singleRoadmapRes.description || "";
    const isInitialLoad = !currentDescRaw && initialDescRaw;

    const currentDescNormalized = normalizeDescription(currentDescRaw);
    const initialDescNormalized = normalizeDescription(initialDescRaw);
    const descExactMatch = currentDescNormalized === initialDescNormalized;
    const descContentMatch =
      currentDescNormalized.replace(/\s/g, "") ===
      initialDescNormalized.replace(/\s/g, "");

    const descriptionChanged =
      !isInitialLoad && !descExactMatch && !descContentMatch;
    const priorityChanged =
      normalizePriority(payloadData.priority) !==
      normalizePriority(singleRoadmapRes.priority);

    const currentProjectIds = selectedProjects.map((p) => p.project_id).sort();
    const initialProjectIds = (singleRoadmapRes.projects || [])
      .map((p: any) => p.project_id)
      .sort();

    const projectsChanged =
      JSON.stringify(currentProjectIds) !== JSON.stringify(initialProjectIds);

    const milestonesChanged =
      JSON.stringify(milestones) !==
      JSON.stringify(singleRoadmapRes.milestones || []);

    const normalizeDependencies = (deps: any[]) => {
      return deps
        .map((dep) => ({
          project_to: {
            value: dep.project_to?.value,
            label: dep.project_to?.label,
          },
          project_on: (dep.project_on || [])
            .map((p: any) => ({
              value: p.value,
              label: p.label,
              project_id: p.project_id,
            }))
            .sort((a: any, b: any) => {
              const aId = String(a.value || a.project_id || "");
              const bId = String(b.value || b.project_id || "");
              return aId.localeCompare(bId);
            }),
        }))
        .sort((a, b) => {
          const aId = String(a.project_to?.value || "");
          const bId = String(b.project_to?.value || "");
          return aId.localeCompare(bId);
        });
    };

    const currentDepsNormalized = normalizeDependencies(dependencies);
    const initialDepsNormalized = normalizeDependencies(
      transformProjectDependencyData(
        singleRoadmapRes?.dependencies || [],
        singleRoadmapRes?.projects || [],
      ),
    );
    const dependenciesChanged =
      JSON.stringify(currentDepsNormalized) !==
      JSON.stringify(initialDepsNormalized);

    const statusChanged =
      (payloadData.stage || "executing") !==
      (singleRoadmapRes.stage || "executing");
    return (
      nameChanged ||
      descriptionChanged ||
      priorityChanged ||
      projectsChanged ||
      milestonesChanged ||
      dependenciesChanged ||
      statusChanged
    );


  }, [
    roadmap_id,
    payloadData,
    selectedProjects
  ]);


  const handleOnChange = (e: any) => {
    const { name, value } = e.target;
    const data = { ...payloadData, [name]: value };
    setPayloadData(data);
  };

  const handleDescriptionChange = (value: string) => {
    const data = { ...payloadData, description: value };
    setPayloadData(data);
  };

  const handleProjectCheckbox = (e: any, project?: any) => {
    setSelectedProjects((prev) => {
      if (e.target.checked) {
        return [
          ...prev,
          {
            ...project,
          },
        ];
      } else {
        const isDependent = dependencies.some((dep) => {
          if (dep.project_to?.value === project.project_id) return true;
          if (
            dep.project_on?.some(
              (p: any) =>
                p.value === project.project_id ||
                p.project_id === project.project_id,
            )
          )
            return true;
          return false;
        });

        if (isDependent) {
          toast.error(
            "This feature is linked to a dependency. Please remove the dependency before unlinking the feature.",
          );
          return prev;
        }
        return prev.filter((proj) => proj.project_id !== project.project_id);
      }
    });
  };

  const onSubmit = async () => {
    const isMilestonesFlag = checkForEmptyKeys(milestones);
    const dependenciesData = createDependenciesPayload();
    let d: any = {
      name: payloadData?.name || "",
      projects: selectedProjects.map((proj) => proj.project_id),
      description: payloadData?.description || "",
      priority: payloadData?.priority || "",
      entity_type: "epic",
      dependencies: dependenciesData,
      stage: payloadData?.stage || "executing",
      milestones,
    };
    if (saveRoadmapLoading) {
      toast.error("Backend is processing something.");
      return;
    }

    if (!d.name) {
      toast.error(`Please fill Epic name.`);
      return;
    }

    // Improved validation for rich text editor content
    const strippedDescription = d.description?.replace(/<[^>]*>/g, "").trim();
    if (
      !d.description ||
      !strippedDescription ||
      d.description === "<p></p>" ||
      d.description === "<p><br></p>" ||
      d.description === "<p><br/></p>"
    ) {
      toast.error(`Please fill Epic description.`);
      return;
    }
    if (!selectedProjects.length) {
      toast.error(
        `Please select atleast one ${singularEntityType.toLowerCase()}.`,
      );
      return;
    }
    if (!selectedProjects.length) {
      toast.error(
        `Please select atleast one ${singularEntityType.toLowerCase()}.`,
      );
      return;
    }
    if (!isMilestonesFlag) {
      toast.error("Please fill mandatory field in milestone.");
      return;
    }
    if (payloadData.id) {
      await updateRoadmap(payloadData.id, { ...d }).then(() => {
        setSelectedRoadmap({});
      });
    } else {
      const res = await saveRoadmap({ ...d, ...payloadData });

      
      setSelectedRoadmap({});

      if (onCreate && res) {
        onCreate(res);
      }
      
      if (!preventRedirect) {
        navigate(`/roadmaps/${res?.roadmap_id}`);
      }
    }
    handleCancel();
  };

  const handleDelete = (status: boolean) => {
    setShowDeleteConfirm(status);
  };

  const submitDelete = async () => {
    if (roadmap_id) {
      try {
        setIsDeleting(true);
        await deleteRoadmap(roadmap_id);
        setShowDeleteConfirm(false);
        setShowModal(false);

        if (roadmapIdArg) {
          // Check if accessed from Projects page (/roadmaps route) or Strategy Maps page (/strategymaps route)
          const isFromProjects = location.pathname.includes("/roadmaps/");
          navigate(isFromProjects ? "/workitems" : "/strategymaps");
        }
      } catch (error) {
        console.error("Error deleting roadmap:", error);
      } finally {
        setIsDeleting(false);
      }
    }
  };

  const handleCancel = () => {
    if (!roadmapIdArg) {
      setSelectedProjects([]);
      setPinnedProjects([]);
      setDependencies([]);
      setMilestones([]);
      setPayloadData({});
      dispatch(setSingleRoadmap({}));
    }
    setShowModal(false);
  };

  const handleAddMilestoneClick = () => {
    const _uid = new Date().getTime().toString();
    const data: any = [...milestones];
    data.push({
      _uid,
      name: "",
      color: "#000000",
      start_date: null,
      id: 0,
    });
    setMilestones(data);
  };
  const handleAddDependenciesClick = () => {
    const _uid = new Date().getTime().toString();
    const data: any = [...dependencies];
    data.push({
      _uid,
      project_to: "",
      project_on: [],
    });
    setDependencies(data);
  };

  const handleOnDateChange = (date: any, index: number) => {
    try {
      const data: any = [...milestones];
      const _cur = { ...data[index] };
      _cur["start_date"] = date;
      data[index] = _cur;
      setMilestones(data);
    } catch (error) {
      console.log("error   ", error);
    }
  };
  const handleMilestoneChange = (e: any, index: number) => {
    const data: any = [...milestones];
    const val = e.target.value;
    const name = e.target.name;
    const _cur = { ...data[index] };
    _cur[name] = val;
    data[index] = _cur;
    setMilestones(data);
  };
  const handleMilestoneClick = (i: number) => {
    const data: any = [...milestones];
    const payload = data.filter((d: any, index: number) => index !== i);
    setMilestones(payload);
  };

  const handleDependenciesClick = (i: number) => {
    const data: any = [...dependencies];
    const payload = data.filter((d: any, index: number) => index !== i);
    setDependencies(payload);
  };

  const checkForEmptyKeys = (_d: any[]) => {
    let flag = true;
    _d.forEach((element: any) => {
      if (!element.name) {
        flag = false;
      }
      if (!element.start_date) {
        flag = false;
      }
    });
    return flag;
  };

  const createDependenciesPayload = () => {
    let data: any = [];
    dependencies.forEach((depend: any) => {
      if (depend?.project_to && depend.project_on.length) {
        const d = {
          dependency: [...depend.project_on],
          project_id: depend?.project_to?.value,
          project_start_date: depend?.project_to?.start_date,
          project_end_date: depend?.project_to?.start_date,
        };
        data.push(d);
      }
    });
    return data;
  };

  const handleTabsToggle = (e: SyntheticEvent, tab: number) => {
    setActiveTabs(tab);
  };

  const handleOnSelectChange = (
    value: SingleValue<{ value: string; label: string }>,
    uid: any,
  ) => {
    const data: any = [...dependencies];
    const referenceProject = data.find(
      (project: any) => project.project_to.value === value?.value,
    );
    if (!referenceProject) {
      const updatedProjects = data.map((project: { _uid: any }) =>
        project._uid === uid
          ? { ...project, project_to: value, project_on: [] }
          : project,
      );
      setDependencies(updatedProjects);
    } else {
      toast.error("The project has already been selected.");
    }
  };
  const handleOnMultiSelectChange = (value: MultiValue<string>, uid: any) => {
    const data: any = [...dependencies];
    const updatedProjects = data.map((project: { _uid: any }) =>
      project._uid === uid ? { ...project, project_on: value } : project,
    );
    setDependencies(updatedProjects);
  };

  const [sortBy, setSortBy] = useState("modified_at_desc");

  const handleSortChange = (value: any) => {
    const sortValue = value.target.value;
    setSortBy(sortValue);
    if (org_id && !orgLoading) {
      fetchProjectsList({
        org_id,
        reset: true,
        pageNumber: 1,
        searchTerm: searchQuery,
        sortBy: sortValue,
        include_data: ["roadmap_data"],
        item_type: "feature",
      });
    }
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    // Update local state immediately
    setSearchQuery(value);

    if (!isIntegrationReadOnly) {
      // Clear existing timeout
      if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);

      // Set new timeout for API call and Redux update
      searchDebounceRef.current = setTimeout(() => {
        // Update Redux store's searchTerm
        dispatch(setSearchTerm(value));

        // Call API directly for immediate response with current input value
        if (org_id && !orgLoading) {
          fetchProjectsList({
            org_id,
            reset: true,
            pageNumber: 1,
            searchTerm: value,
            sortBy: sortBy,
            include_data: ["roadmap_data"],
            item_type: "feature",
          });
        }
      }, 400); // 400ms debounce
    }
  };

  const handleClearSearch = () => {
    setSearchQuery("");
    if (!isIntegrationReadOnly) {
      if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
      dispatch(setSearchTerm(""));

      // Call API directly when clearing search
      if (org_id && !orgLoading) {
        fetchProjectsList({
          org_id,
          reset: true,
          pageNumber: 1,
          searchTerm: "",
          sortBy: sortBy,
          include_data: ["roadmap_data"],
          item_type: "feature",
        });
      }
    }
  };

  const getProjectList = () => {
    const optionsArr: any = [];
    selectedProjects.forEach((element) => {
      if (
        element.project_id &&
        !dependencies
          .map((dependency) => dependency.project_to.value)
          .includes(element.project_id)
      ) {
        optionsArr.push({
          value: element.project_id,
          project_id: element.project_id,
          label: element.project_name,
          project_end_date: element.end_date,
          start_date: element.start_date,
        });
      }
    });
    return optionsArr.sort(
      (a: { isDisabled: boolean }, b: { isDisabled: boolean }) =>
        Number(a.isDisabled) - Number(b.isDisabled),
    );
  };

  const getFilterProjectList = (project_id: any) => {
    const optionsArr: any = [];

    // Find the reference project details
    const referenceProject = selectedProjects.find(
      (project) => project.project_id === project_id,
    );

    if (!referenceProject) return optionsArr; // Return empty if project_id not found

    const { start_date: refStartDate, end_date: refEndDate } = referenceProject;

    if (selectedProjects.length) {
      selectedProjects.forEach((element) => {
        const hasElementStartedBefore =
          new Date(element.start_date!) <= new Date(refStartDate!);
        const hasElementEndedBefore =
          new Date(element.end_date!) <= new Date(refEndDate!);
        const isEnabled =
          element.project_id !== project_id &&
          hasElementStartedBefore &&
          hasElementEndedBefore;

        let errorText = "";

        if (!isEnabled) {
          if (hasElementStartedBefore) {
            if (hasElementEndedBefore) {
              errorText =
                "Cannot select projects which start before and end before this project";
            } else {
              errorText =
                "Cannot select projects which start before and end after this project";
            }
          } else {
            if (hasElementEndedBefore) {
              errorText =
                "Cannot select projects which start after and end before this project";
            } else {
              errorText =
                "Cannot select projects which start after and end after this project";
            }
          }
        }

        optionsArr.push({
          value: element.project_id,
          project_id: element.project_id,
          label: element.project_name,
          project_start_date: element.start_date,
          project_end_date: element.end_date,
          isDisabled: !isEnabled,
          error: errorText,
        });
      });
    }
    return optionsArr.sort(
      (a: { isDisabled: boolean }, b: { isDisabled: boolean }) =>
        Number(a.isDisabled) - Number(b.isDisabled),
    );
  };

  const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    if (
      scrollHeight - scrollTop <= clientHeight + 50 &&
      !orgLoading &&
      !loadingMore &&
      hasMore
    ) {
      fetchProjectsList({
        org_id,
        reset: false,
        pageNumber: page + 1,
        searchTerm: searchQuery,
        sortBy: sortBy,
        include_data: ["roadmap_data"],
        item_type: "feature",
      });
    }
  };

  // When in read-only mode (integration data present), only show previously selected work units
  const getDisplayedProjects = () => {
    if (!isIntegrationReadOnly) {
      const pinnedIds = new Set(pinnedProjects.map((p: any) => p.project_id));
      return projects.filter((p: any) => !pinnedIds.has(p.project_id));
    }
    const source = singleRoadmapRes?.projects || [];
    const filtered = searchQuery
      ? source.filter((p: any) =>
          (p.project_name || "")
            .toLowerCase()
            .includes(searchQuery.toLowerCase()),
        )
      : source;
    return [...filtered].sort((a: any, b: any) => {
      const dateA = a.start_date ? new Date(a.start_date).getTime() : 0;
      const dateB = b.start_date ? new Date(b.start_date).getTime() : 0;
      if (dateA !== dateB) return dateA - dateB;
      return (a.project_name || "")
        .toLowerCase()
        .localeCompare((b.project_name || "").toLowerCase());
    });
  };

  return (
    <>
      <div className="h-full w-full flex flex-col bg-light-surfacePrimary dark:bg-tertiary-dark overflow-hidden animate-fade-in">
        {singleRoadmapLoading ? (
          <div className="flex-1 overflow-y-auto">
            <div className="px-4 py-4 space-y-6">
              {/* Header Skeleton */}
              <div className="space-y-4">
                <div className="space-y-2">
                  <Label
                    htmlFor="roadmapname"
                    className="text-base font-medium text-light-text-primary dark:text-white"
                  >
                    Epic name*
                  </Label>
                  <div className="h-12 bg-gray-200 dark:bg-gray-700 rounded-xl animate-pulse"></div>
                </div>
                <div className="space-y-2">
                  <Label
                    htmlFor="projectname"
                    className="text-base font-medium text-light-text-primary dark:text-white"
                  >
                    Epic description*
                  </Label>
                  <div className="rounded-xl overflow-hidden border border-light-border-default dark:border-hover-dark shadow-sm">
                    <RichTextEditor
                      content={``}
                      onChange={() => {}}
                      disabled={false}
                      placeholder=""
                    />
                  </div>
                </div>
                <div className="flex">
                  <div className="space-y-2">
                    <Label
                      htmlFor="priority"
                      className="text-base font-medium text-light-text-primary dark:text-white"
                    >
                      Epic Priority
                    </Label>
                    <div className="h-12 bg-gray-200 dark:bg-gray-700 rounded-xl animate-pulse"></div>
                  </div>
                </div>
              </div>

              {/* Tabs Skeleton */}
              <div className="bg-light-surface dark:bg-tertiary-dark rounded-sm p-1 border-b border-light-border-default dark:border-hover-dark">
                <div className="flex space-x-4 p-3">
                  <div className="h-6 w-20 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
                  <div className="h-6 w-24 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
                  <div className="h-6 w-28 bg-gray-200 dark:bg-gray-700 rounded animate-pulse"></div>
                </div>
              </div>

              {/* Content Skeleton */}
              <div className="space-y-6 -mt-2">
                {/* Search Bar Skeleton */}
                <div className="bg-light-surfacePrimary dark:bg-secondary-dark rounded-xl border border-light-border-default dark:border-hover-dark shadow-sm">
                  <div className="h-12 bg-gray-200 dark:bg-gray-700 rounded-xl animate-pulse"></div>
                </div>

                {/* Project Items Skeleton */}
                <div className="flex flex-col gap-4">
                  {[...Array(6)].map((_, index) => (
                    <EnhancedProjectSkeleton
                      isReadOnly={isIntegrationReadOnly}
                      key={`skeleton-${index}`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex-1 overflow-y-auto">
            <div className="px-6 py-4 space-y-6">
              <div className="space-y-4 ">
                <div className="flex w-full gap-4">
                  <div className="space-y-2 w-full">
                    <Label
                      htmlFor="roadmapname"
                      className="text-base font-medium text-light-text-primary dark:text-white"
                    >
                      Epic name*
                    </Label>
                    <input
                      type="text"
                      id="roadmapname"
                      className="block w-full px-4 py-3 disabled:pointer-events-none text-light-text-primary border border-light-border-default bg-light-surfaceSecondary text-base focus:ring-2 focus:ring-primary-light focus:border-primary-light placeholder:text-light-input-placeholder transition-all duration-200 dark:bg-secondary-dark dark:border-hover-dark dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-dark dark:focus:border-primary-dark rounded-xl shadow-sm hover:border-light-border-interactive hover:shadow-md"
                      onChange={handleOnChange}
                      name="name"
                      placeholder={`Epic name`}
                      defaultValue={payloadData.name}
                      disabled={saveRoadmapLoading}
                    />
                  </div>

                  {roadmap_id && (
                    <div className="space-y-2">
                      <Label className="text-base font-medium text-light-text-primary dark:text-white">
                        Epic Stage*
                      </Label>
                      <HeadlessSelect
                        id="status"
                        name="stage"
                        value={payloadData.stage || "executing"}
                        onChange={(data) => {
                          console.log(data);
                          handleOnChange(data);
                        }}
                        options={[
                          { value: "planning", label: "Planning" },
                          { value: "executing", label: "Executing" },
                          { value: "closed", label: "Closed" },
                          ...(payloadData?.status === "simulated"
                            ? [{ value: "simulated", label: "Simulated" }]
                            : []),
                        ]}
                        placeholder={`Choose ${singularEntityType_Main.toLowerCase()} status`}
                        disabled={!roadmap_id}
                      />
                    </div>
                  )}
                </div>

                <div className="space-y-2">
                  <Label
                    htmlFor="projectname"
                    className="text-base font-medium text-light-text-primary dark:text-white"
                  >
                    Epic description*
                  </Label>
                  <div className="rounded-xl overflow-hidden border border-light-border-default dark:border-hover-dark shadow-sm hover:shadow-md transition-shadow duration-200">
                    <RichTextEditor
                      content={payloadData.description || ""}
                      onChange={handleDescriptionChange}
                      disabled={saveRoadmapLoading}
                      placeholder={`Epic description`}
                    />
                  </div>
                </div>
                <div className="w-full">
                  <div className="space-y-2 w-full">
                    <Label
                      htmlFor="priority"
                      className="text-base font-medium text-light-text-primary dark:text-white"
                    >
                      Epic Priority
                    </Label>
                    <CustomDropdown
                      id="priority"
                      name="priority"
                      value={payloadData.priority || ""}
                      options={internalPriorityOptions}
                      onChange={(val) => handleOnChange({ target: { name: "priority", value: val } })}
                      placeholder="Select Priority"
                      className="!mb-0"
                    />
                  </div>
                </div>
              </div>

              <div
                className="bg-light-surface dark:bg-tertiary-dark rounded-sm p-1 border-b border-light-border-default dark:border-hover-dark"
                ref={tabsRef}
              >
                <Box
                  sx={{ borderBottom: 0, borderColor: "gray" }}
                  className="text-light-text-primary dark:text-white"
                >
                  <Tabs
                    value={activeTabs}
                    onChange={handleTabsToggle}
                    aria-label=""
                    sx={{
                      "& .MuiTabs-indicator": {
                        backgroundColor:
                          mode === "dark" ? "#1d64f3" : "#1d64f3",
                        height: 3,
                        borderRadius: "2px",
                      },
                      "& .MuiTab-root": {
                        borderRadius: 0,
                        margin: "0 4px",
                        minHeight: "48px",
                        background: "none",
                        transition: "all 0.2s ease-in-out",
                        boxShadow: "none",
                        textTransform: "none",
                      },
                      "& .Mui-selected": {
                        background: "none",
                      },
                    }}
                  >
                    <Tab
                      label={"Features"}
                      {...a11yProps(0)}
                      sx={{
                        color: mode === "dark" ? "white" : "#4b5563",
                        fontWeight: 500,
                        background: "none",
                        boxShadow: "none",
                        textTransform: "none",
                        "&.Mui-selected": {
                          color: mode === "dark" ? "#1d64f3" : "#1d64f3",
                          background: "none",
                        },
                      }}
                    />
                    {/* {selectedProjects.length ? (
                      <Tab
                        label="Dependencies"
                        {...a11yProps(1)}
                        sx={{
                          color: mode === "dark" ? "white" : "#4b5563",
                          fontWeight: 500,
                          background: "none",
                          boxShadow: "none",
                          textTransform: "none",
                          "&.Mui-selected": {
                            color: mode === "dark" ? "#1d64f3" : "#1d64f3",
                            background: "none",
                          },
                        }}
                      />
                    ) : (
                      ""
                    )}
                    <Tab
                      label="Milestone"
                      {...a11yProps(selectedProjects.length > 0 ? 2 : 1)}
                      sx={{
                        color: mode === "dark" ? "white" : "#4b5563",
                        fontWeight: 500,
                        background: "none",
                        boxShadow: "none",
                        textTransform: "none",
                        "&.Mui-selected": {
                          color: mode === "dark" ? "#1d64f3" : "#1d64f3",
                          background: "none",
                        },
                      }}
                    /> */}

                    {!isIntegrationReadOnly &&
                    <button
                    className="ml-auto mt-3 h-fit text-[12px] py-2 bg-slate-800 text-white px-5 rounded-full flex items-center gap-2 hover:bg-slate-700 transition-colors"
                    onClick={() => setShowCreateFeature(true)}
                    >
                      <FaPlusCircle className="text-[12px]" />
                      Create Feature
                    </button>
                    }
                  </Tabs>
                </Box>
              </div>
              <CustomTabPanel value={activeTabs} index={0}>
                <div className="space-y-4 -mt-2">
                  <div className="bg-light-surfacePrimary dark:bg-secondary-dark rounded-xl border border-light-border-default dark:border-hover-dark shadow-sm">
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 flex items-center pl-4 pointer-events-none">
                        <FaSearch className="w-5 h-5 text-light-text-secondary dark:text-gray-400"></FaSearch>
                      </div>
                      <input
                        type="text"
                        id="project-search"
                        className="block w-full px-4 py-3 pl-12 text-base text-light-text-primary border border-light-border-default rounded-xl bg-light-surfaceSecondary focus:ring-2 focus:ring-primary-light focus:border-primary-light placeholder:text-light-input-placeholder transition-all duration-200 dark:bg-tertiary-dark dark:border-hover-dark dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-dark dark:focus:border-primary-dark shadow-sm hover:border-light-border-interactive hover:shadow-md"
                        placeholder={`Search Features...`}
                        value={searchQuery}
                        onChange={handleSearchChange}
                      />
                      {searchQuery && (
                        <button
                          className="absolute inset-y-0 right-0 flex items-center px-4 text-light-text-secondary hover:text-light-text-primary dark:text-gray-400 dark:hover:text-white transition-colors duration-200"
                          onClick={handleClearSearch}
                          title="Clear search"
                        >
                          <FaTimes className="w-5 h-5 text-light-text-secondary dark:text-gray-400" />
                        </button>
                      )}
                    </div>
                  </div>

                  {!isIntegrationReadOnly && (
                    <div className="flex items-center justify-between text-xs text-light-text-tertiary dark:text-gray-400 px-1 -mb-2">
                      <div className="flex gap-2 items-center">
                        <span>
                          Showing {projects.length} of {totalItems} items
                        </span>
                        {/* {totalItems > 0 && <span>Page {page}</span>} */}
                      </div>
                      <div className=" scale-90 origin-right z-20">
                        <SortByDropdown
                          value={sortBy}
                          onChange={handleSortChange}
                        />
                      </div>
                    </div>
                  )}

                  {/* Main Content Area */}
                  <div
                    className="max-h-[500px] overflow-y-auto pr-2"
                    onScroll={handleScroll}
                  >
                    {/* Initial loading state for projects list (editable only) */}
                    {isIntegrationReadOnly ? (
                      getDisplayedProjects().length === 0 ? (
                        <div className="text-center p-4 text-light-text-secondary dark:text-gray-300">
                          {searchQuery
                            ? `No ${childEntityType.toLowerCase()} found matching your search`
                            : `No ${childEntityType.toLowerCase()} found`}
                        </div>
                      ) : (
                        <div className="flex flex-col gap-4">
                          {getDisplayedProjects().map((project: any) => {
                            const isRoadmapPresent = project.is_roadmap_present;
                            const roadmapName =
                              project.roadmap_data?.roadmap_name || "NA";

                            return (
                              <EntityItem
                                key={project.project_id}
                                item={
                                  {
                                    ...project,
                                    id: project.project_id || "",
                                    name: project.project_name || "",
                                  } as any
                                }
                                isSelected={
                                  selectedProjects &&
                                  selectedProjects
                                    .map((el) => el.project_id)
                                    .includes(project?.project_id)
                                }
                                onToggle={() =>
                                  handleProjectCheckbox(
                                    {
                                      target: {
                                        checked: !selectedProjects.some(
                                          (p) =>
                                            p.project_id === project.project_id,
                                        ),
                                      },
                                    },
                                    project,
                                  )
                                }
                                isDisabled={isRoadmapPresent}
                                readOnly={isIntegrationReadOnly}
                                tooltipMessage={
                                  isRoadmapPresent
                                    ? `Cannot link item as its already linked to '${roadmapName}' Epic`
                                    : null
                                }
                                extraInfo={
                                  <>
                                    <div className="entity-item__stat-group min-w-[100px] hidden sm:flex">
                                      <div className="entity-item__stat-label">
                                        Start Date
                                      </div>
                                      <div className="entity-item__stat-value">
                                        {project?.start_date
                                          ? formatDateBy(project?.start_date)
                                          : "..."}
                                      </div>
                                    </div>
                                  </>
                                }
                              />
                            );
                          })}
                        </div>
                      )
                    ) : orgLoading ? (
                      <div className="flex flex-col gap-4">
                        {[...Array(10)].map((_, index) => (
                          <EntityItemSkeleton
                            key={`initial-skeleton-${index}`}
                          />
                        ))}
                      </div>
                    ) : projects.length === 0 ? (
                      <div className="text-center p-4 text-light-text-secondary dark:text-gray-300">
                        {searchQuery
                          ? `No ${childEntityType.toLowerCase()} found matching your search`
                          : `No ${childEntityType.toLowerCase()} found`}
                      </div>
                    ) : (
                      // Display the filtered and sorted projects
                      <div className="flex flex-col gap-4">
                        {pinnedProjects.map((project) => {
                          const isRoadmapPresent = project.is_roadmap_present;
                          const roadmapName =
                            project.roadmap_data?.roadmap_name || "NA";

                          const isCadence =
                            (project?.source || "cadence").toLowerCase() ===
                            "cadence";
                          const isSelected =
                            selectedProjects &&
                            selectedProjects
                              .map((el) => el.project_id)
                              .includes(project?.project_id);
                          const isDisabled =
                            isRoadmapPresent || (!isCadence && !isSelected);

                          const getTooltipMessage = () => {
                            if (isRoadmapPresent)
                              return `Can't edit because it's already added in ${roadmapName}`;
                            if (!isCadence && !isSelected)
                              return `This is a Cadence Epic. You cannot add ${project?.source} features.`;
                            return null;
                          };

                          return (
                            <EntityItem
                              key={project.project_id}
                              item={
                                {
                                  ...project,
                                  id: project.project_id || "",
                                  name: project.project_name || "",
                                } as any
                              }
                              isSelected={isSelected}
                              onToggle={() =>
                                handleProjectCheckbox(
                                  {
                                    target: {
                                      checked: !selectedProjects.some(
                                        (p) =>
                                          p.project_id === project.project_id,
                                      ),
                                    },
                                  },
                                  project,
                                )
                              }
                              isDisabled={isDisabled}
                              tooltipMessage={getTooltipMessage()}
                              extraInfo={
                                <>
                                  <div className="entity-item__stat-group min-w-[100px] hidden sm:flex">
                                    <div className="entity-item__stat-label">
                                      Start Date
                                    </div>
                                    <div className="entity-item__stat-value">
                                      {project?.start_date
                                        ? formatDateBy(project?.start_date)
                                        : "..."}
                                    </div>
                                  </div>
                                </>
                              }
                            />
                          );
                        })}
                        {getDisplayedProjects().map((project: any) => {
                          const isRoadmapPresent = project.is_roadmap_present;
                          const roadmapName =
                            project.roadmap_data?.roadmap_name || "NA";
                          const isCadence =
                            (project?.source || "cadence").toLowerCase() ===
                            "cadence";
                          const isDisabled = isRoadmapPresent || !isCadence;

                          const getTooltipMessage = () => {
                            if (isRoadmapPresent)
                              return `Cannot link item as its already linked to '${roadmapName}' Epic`;
                            if (!isCadence)
                              return `This is a Cadence Epic. You cannot add ${project?.source} features.`;
                            return null;
                          };

                          return (
                            <EntityItem
                              key={project.project_id}
                              item={
                                {
                                  ...project,
                                  id: project.project_id || "",
                                  name: project.project_name || "",
                                } as any
                              }
                              isSelected={
                                selectedProjects &&
                                selectedProjects
                                  .map((el) => el.project_id)
                                  .includes(project?.project_id)
                              }
                              onToggle={() =>
                                handleProjectCheckbox(
                                  {
                                    target: {
                                      checked: !selectedProjects.some(
                                        (p) =>
                                          p.project_id === project.project_id,
                                      ),
                                    },
                                  },
                                  project,
                                )
                              }
                              isDisabled={isDisabled}
                              tooltipMessage={getTooltipMessage()}
                              extraInfo={
                                <>
                                  <div className="entity-item__stat-group min-w-[100px] hidden sm:flex">
                                    <div className="entity-item__stat-label">
                                      Start Date
                                    </div>
                                    <div className="entity-item__stat-value">
                                      {project?.start_date
                                        ? formatDateBy(project?.start_date)
                                        : "..."}
                                    </div>
                                  </div>
                                </>
                              }
                            />
                          );
                        })}
                        {/* Show loading skeletons when loading more */}
                        {loadingMore && (
                          <div className="flex flex-col gap-4">
                            {[...Array(3)].map((_, index) => (
                              <EntityItemSkeleton />
                            ))}
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </CustomTabPanel>
              {selectedProjects.length > 0 && (
                <CustomTabPanel value={activeTabs} index={1}>
                  <div className="flex flex-col gap-5 ">
                    <div className="text-light-text-primary dark:text-white text-lg font-bold flex font-['Inter'] border-b border-light-border dark:border-hover-dark pb-5">
                      <div className="">Dependencies</div>
                      <div
                        className="ml-auto cursor-pointer hover:text-primary-light dark:hover:text-primary-dark text-sm"
                        onClick={handleAddDependenciesClick}
                      >
                        {" "}
                        + Add{" "}
                      </div>
                    </div>
                    <div className="flex flex-col">
                      {dependencies.map((dependencie: any, index) => {
                        return (
                          <div
                            className="grid grid-cols-2 gap-10 justify-start items-start relative"
                            key={`${dependencie._uid}_${index}`}
                          >
                            <div className="flex flex-col mb-4   w-full">
                              <Label
                                htmlFor="team_size"
                                className="block text-sm font-medium "
                              >
                                {singularEntityType}
                              </Label>
                              <Select
                                className="rounded-md w-full"
                                isMulti={false}
                                classNamePrefix="resourcesContainer"
                                defaultValue={dependencie.project_to}
                                value={dependencie.project_to}
                                onChange={(value) =>
                                  handleOnSelectChange(value, dependencie._uid)
                                }
                                options={getProjectList()}
                                isClearable={false}
                                styles={{
                                  control: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: "#e5e7eb",
                                    borderColor: state.isFocused
                                      ? "#1d64f3"
                                      : "#E0E0E0",
                                    borderRadius: "0.5rem",
                                    boxShadow: state.isFocused
                                      ? "0 0 0 2px #1d64f3"
                                      : "none",
                                    "&:hover": {
                                      borderColor: "#c4c7d0",
                                    },
                                  }),
                                  menu: (provided) => ({
                                    ...provided,
                                    backgroundColor: "#F9FAFB",
                                    border: "1px solid #E0E0E0",
                                    borderRadius: "0.5rem",
                                  }),
                                  option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isSelected
                                      ? "#1d64f3"
                                      : state.isFocused
                                        ? "#f3f4f6"
                                        : "#F9FAFB",
                                    color: state.isSelected
                                      ? "#fff"
                                      : "#111827",
                                  }),
                                }}
                              />
                            </div>
                            <div className="flex flex-col mb-4   w-full">
                              <Label
                                htmlFor="team_size"
                                className="block text-sm font-medium "
                              >
                                Depends On
                              </Label>
                              <Select
                                className="rounded-md"
                                isMulti
                                classNamePrefix="resourcesContainer"
                                defaultValue={dependencie.project_on}
                                value={dependencie.project_on}
                                onChange={(value) =>
                                  handleOnMultiSelectChange(
                                    value,
                                    dependencie._uid,
                                  )
                                }
                                options={getFilterProjectList(
                                  dependencie?.project_to?.value,
                                )}
                                isClearable={false}
                                styles={{
                                  control: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: "#e5e7eb",
                                    borderColor: state.isFocused
                                      ? "#1d64f3"
                                      : "#E0E0E0",
                                    borderRadius: "0.5rem",
                                    boxShadow: state.isFocused
                                      ? "0 0 0 2px #1d64f3"
                                      : "none",
                                    "&:hover": {
                                      borderColor: "#c4c7d0",
                                    },
                                  }),
                                  menu: (provided) => ({
                                    ...provided,
                                    backgroundColor: "#F9FAFB",
                                    border: "1px solid #E0E0E0",
                                    borderRadius: "0.5rem",
                                  }),
                                  option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isSelected
                                      ? "#1d64f3"
                                      : state.isFocused
                                        ? "#f3f4f6"
                                        : "#F9FAFB",
                                    color: state.isSelected
                                      ? "#fff"
                                      : "#111827",
                                  }),
                                  multiValue: (provided) => ({
                                    ...provided,
                                    backgroundColor: "#374151",
                                    border: "1px solid #4b5563",
                                    borderRadius: "0.375rem",
                                  }),
                                  multiValueLabel: (provided) => ({
                                    ...provided,
                                    color: "#ffffff",
                                    fontWeight: "500",
                                  }),
                                  multiValueRemove: (provided) => ({
                                    ...provided,
                                    color: "#d1d5db",
                                    "&:hover": {
                                      backgroundColor: "#dc2626",
                                      color: "#fff",
                                    },
                                  }),
                                }}
                                components={{
                                  Option: (props) => {
                                    const { data, innerRef, innerProps } =
                                      props;

                                    return data.isDisabled ? (
                                      <div
                                        ref={innerRef}
                                        {...innerProps}
                                        className="cursor-not-allowed px-2 py-1"
                                      >
                                        <Tooltip content={data.error}>
                                          <span className="opacity-60 ">
                                            {data.label}
                                          </span>
                                        </Tooltip>
                                      </div>
                                    ) : (
                                      <components.Option {...props} />
                                    );
                                  },
                                }}
                              />
                              <Tooltip
                                placement="bottom"
                                className=""
                                content={`Try this prompt`}
                              />
                            </div>
                            <div
                              className="absolute right-[-10px] top-0 bg-red-600 text-white rounded-full w-4 h-4 text-xs px-1 cursor-pointer"
                              onClick={() => handleDependenciesClick(index)}
                            >
                              X
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </CustomTabPanel>
              )}

              <CustomTabPanel
                value={activeTabs}
                index={selectedProjects.length > 0 ? 2 : 1}
              >
                <div className="flex flex-col gap-5 ">
                  <div className="text-light-text-primary dark:text-white text-lg font-bold flex font-['Inter'] border-b border-light-border dark:border-hover-dark pb-5">
                    <div className="">Milestone</div>
                    <div
                      className="ml-auto cursor-pointer hover:text-primary-light dark:hover:text-primary-dark text-sm"
                      onClick={handleAddMilestoneClick}
                    >
                      {" "}
                      + Add{" "}
                    </div>
                  </div>
                  <div className="flex flex-col">
                    {milestones.map((milestone: any, index) => {
                      return (
                        <div
                          className="flex gap-10 justify-start items-center relative"
                          key={milestone._uid}
                        >
                          <div className="mb-5">
                            <Label htmlFor="milestone_name">Name *</Label>
                            <div className="mt-1">
                              <div className="mb-2">
                                <input
                                  id="milestone_name"
                                  type="text"
                                  className="block w-full p-2.5 disabled:pointer-events-none text-light-text-primary border border-light-border-default bg-light-surfaceSecondary sm:text-md focus:ring-2 focus:ring-primary-light focus:border-primary-light placeholder:text-light-input-placeholder transition-colors duration-200 dark:bg-secondary-dark dark:border-hover-dark dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-dark dark:focus:border-primary-dark rounded-lg"
                                  onChange={(e) =>
                                    handleMilestoneChange(e, index)
                                  }
                                  name="name"
                                  placeholder="Name"
                                  defaultValue={milestone.name}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="mb-5">
                            <Label htmlFor="milestone_date">Date *</Label>
                            <div className="mt-1">
                              <div className="mb-2">
                                <DatePicker
                                  id="milestone_date"
                                  className="bg-light-surfaceSecondary border border-light-border-default text-light-text-primary text-sm focus:ring-2 focus:ring-primary-light focus:border-primary-light block w-full p-2.5 dark:bg-secondary-dark dark:border-hover-dark dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-dark dark:focus:border-primary-dark rounded-lg"
                                  selected={
                                    milestone?.start_date !== null &&
                                    milestone?.start_date !== undefined &&
                                    milestone?.start_date !== "None"
                                      ? new Date(milestone.start_date)
                                      : null
                                  }
                                  onChange={(date: any) =>
                                    handleOnDateChange(date, index)
                                  }
                                  autoComplete="off"
                                  filterDate={isDateSelectable}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="mb-5">
                            <Label htmlFor="milestone_color">Color</Label>
                            <div className="mt-1">
                              <div className="mb-2">
                                <input
                                  type="color"
                                  id="milestone_color"
                                  onChange={(e) =>
                                    handleMilestoneChange(e, index)
                                  }
                                  name="color"
                                  placeholder="Color"
                                  value={milestone.color}
                                />
                              </div>
                            </div>
                          </div>
                          <div
                            className=" right-0 top-8 bg-red-600 text-white rounded-full w-4 h-4 text-xs px-1 cursor-pointer"
                            onClick={() => handleMilestoneClick(index)}
                          >
                            X
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </CustomTabPanel>
            </div>
            <div className="h-[60px] w-full"></div>
          </div>
        )}

        <div className="flex-shrink-0 px-8 py-4 items-center flex gap-6 border-t border-gray-500 rounded-t-md dark:border-hover-dark bg-light-surfacePrimary dark:bg-tertiary-dark shadow-lg relative bottom-0 w-full z-10">
          <CustomButton
            variant="cancel"
            onClick={handleCancel}
            className="work-unit-drawer__footer-button"
          >
            Back
          </CustomButton>
          <UnsavedChangesIndicator
            hasUnsavedChanges={hasUnsavedChanges}
            className="ml-auto"
          />
          <CustomButton
            onClick={onSubmit}
            disabled={saveRoadmapLoading || (roadmap_id && !hasUnsavedChanges)}
            isLoading={saveRoadmapLoading}
            className={`${hasUnsavedChanges ? "" : "ml-auto"} work-unit-drawer__footer-button`}
          >
            {roadmap_id ? "Update" : "Add"}
          </CustomButton>
        </div>
      </div>

      {showCreateFeature && (
        <Drawer
          isOpen={showCreateFeature}
          setIsOpen={setShowCreateFeature}
          title="Create Feature"
          size={80}
        >
          <CreateFeatureModal
            setShowModal={setShowCreateFeature}
            onCreate={handleFeatureCreated}
            project={{}}
            parent_epic={false}
            preventRedirect={true}
          />
        </Drawer>
      )}
    </>
  );
};

export default CreateEpicAdvancedModalBody;
